<style>
.layout.row {
  margin-bottom: 20px !important;
}

.is-manager-row {
  background: #c5ceff !important;
}

.ustatus-col {
  display: flex;
  align-items: center;
}

.ustatus-col .v-icon.material-icons {
  font-size: 16px;
}

.flex.xs8 {
  align-items: center;
  display: flex;
}

.v-input.ustatus-switch.v-input--selection-controls.v-input--switch .v-input__control {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 100%;
  flex-direction: column-reverse;
}

.v-input.ustatus-switch.v-input--selection-controls.v-input--switch .v-input--switch__thumb {
  border-radius: 50%;
  top: calc(50% - 5px);
  position: relative;
  box-shadow: none !important;
  width: 10px !important;
  height: 10px !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  left: 4px;
}

.v-input.ustatus-switch.v-input--selection-controls.v-input--switch .v-input--switch.v-input--is-dirty .v-input--selection-controls__ripple,
.v-input--switch.v-input--is-dirty .v-input--switch__thumb {
  -webkit-transform: translate(20px, 0) !important;
  transform: translate(20px, 0) !important;
}

.v-input--switch.v-input--is-dirty .v-input--selection-controls__ripple,
.v-input--switch.v-input--is-dirty .v-input--switch__thumb {
  transform: translate(20px) !important;
}

.v-input.ustatus-switch.v-input--selection-controls.v-input--switch .accent--text {
  color: #009688 !important;
  caret-color: #009688 !important;
}

.v-input.ustatus-switch.v-input--selection-controls.v-input--switch {
  width: max-content !important;
  display: flex;
  min-width: 0px;
  max-width: 40px;
}
</style>

<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">Аккаунты</h3>
          <v-btn color="pink" dark small fab @click="editOpen()">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field flat solo prepend-icon="search" placeholder="Поиск" v-model="search" hide-details
                class="hidden-sm-and-down"></v-text-field>
              <v-btn flat style="background-color: none;">
                <v-switch v-model="filterTestAccount" label="Тестовые пользователи" color="error"></v-switch>
              </v-btn>
              <v-btn v-if="!showDetailedSearch" @click="showDetailedSearch = true" icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
              <v-btn v-if="showDetailedSearch" @click="detailedSearchClear" icon>
                <v-icon>clear</v-icon>
              </v-btn>
            </v-toolbar>

            <v-slide-y-transition>
              <v-layout v-if="showDetailedSearch" style="padding-left: 25px;padding-right: 25px;" card color="white">
                <v-flex v-for="sd in detailedSearch" :key="sd.searchKey">
                  <v-text-field flat prepend-icon="search" :placeholder="sd.placeholder" v-model="sd.text" hide-details
                    class="hidden-sm-and-down"></v-text-field>
                </v-flex>
              </v-layout>
            </v-slide-y-transition>

            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table :headers="complex.headers" :search="search" :items="filteredAccountList"
                :rows-per-page-items="[10, 25, 50, 100]" class="elevation-1" item-key="name"
                no-results-text="Нет результатов" rows-per-page-text="На странице" v-model="complex.selected">
                <template slot="items" slot-scope="props">
                  <tr>
                    <td>{{ props.item.id }}</td>
                    <td>{{ props.item.staffId }}</td>
                    <td>{{ props.item.username }}</td>
                    <td>{{ props.item.pgName }}</td>
                    <td>{{ props.item.fullname }}</td>
                    <td>{{ props.item.email }}</td>
                    <td>{{ props.item.phone }}</td>
                    <td>
                      <v-icon color="teal" v-if="props.item.isActive == 1">check</v-icon>
                      <v-icon color="error" v-if="props.item.isActive == 0">close</v-icon>
                    </td>
                    <td class="ustatus-col">
                      <v-switch class="ustatus-switch" v-model="props.item.userStatus"
                        @click="manageStatus(props.item)"></v-switch>
                      <v-icon color="grey" v-if="props.item.userStatus == 0">close</v-icon>
                      <v-icon color="teal" v-if="props.item.userStatus == 1">check</v-icon>
                    </td>
                    <td>
                      <v-btn flat icon dark color="pink" small @click="logsOpen(props.item)">
                        <v-icon>format_align_left</v-icon>
                      </v-btn>

                      <v-btn flat icon dark color="primary" small @click="editOpen(props.item)">
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <v-btn flat icon dark small @click="deactivationConfirm(props.item)">
                        <v-icon v-if="props.item.isActive" color="pink">done_outline</v-icon>
                        <v-icon v-if="!props.item.isActive" color="teal">done_outline</v-icon>
                      </v-btn>
                      <!-- <v-btn
                        depressed
                        outline
                        icon
                        fab
                        dark
                        color="pink"
                        small
                        @click="deactivationConfirm(props.item)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn> -->
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <!-- Окно списка логов -->
              <div slot="widget-content">
                <v-dialog v-model="popupLogs.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Список лог файлов</span>
                    </v-card-title>
                    <v-flex xs6>
                      <v-subheader>{{ popupLogs.nameAccount }}</v-subheader>
                    </v-flex>
                    <v-toolbar card color="white">
                      <v-text-field flat solo prepend-icon="search" placeholder="Поиск" v-model="searchLog" hide-details
                        class="hidden-sm-and-down"></v-text-field>
                      <v-btn icon>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-layout row>
                      <v-data-table :headers="complexLog.headers" :search="searchLog" :items="LogsServerData"
                        :rows-per-page-items="[10, 25, 50, 100]" hide-actions v-bind:pagination.sync="pagination"
                        class="elevation-1" item-key="fileName" no-results-text="Нет результатов"
                        rows-per-page-text="На странице" v-model="complex.selected"
                        style="overflow-y: scroll; height: 500px; width: 100%;">
                        <template slot="items" slot-scope="props">
                          <tr>
                            <td>{{ props.item.fileDate }}</td>
                            <v-btn @click="openJsonLog(props.item)" color="info">Детально
                              <v-icon right dark>list</v-icon>
                            </v-btn>
                            <v-btn @click="openUrl(props.item.fileUrl)" color="success">Файл
                              <v-icon right dark>insert_drive_file</v-icon>
                            </v-btn>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-layout>
                    <v-card-actions>
                      <v-btn flat @click="logsClose()">Закрыть</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
              <!-- Открытие таблицы с детальным логом  -->
              <div slot="widget-content">
                <v-dialog v-model="popupJsonLogs.isOpen" persistent max-width="900px">
                  <v-card>
                    <v-card-title>
                      <v-flex sm12 style="text-align:right">
                        <span style="float:left" class="headline">Детальный просмотр лога</span>
                        <v-btn color="blue" dark small fab @click="refreshJsonLog(popupJsonLogs.jsonFileUrl)">
                          <v-icon>refresh</v-icon>
                        </v-btn>
                        <v-btn dark small fab @click="openUrl(popupJsonLogs.fileUrl)" color="success">
                          <v-icon>insert_drive_file</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-card-title>
                    <v-flex xs6>
                      <v-subheader>{{ popupLogs.nameAccount }} ({{ popupJsonLogs.dateLog }})</v-subheader>
                    </v-flex>
                    <v-toolbar card color="white">
                      <v-text-field flat solo prepend-icon="search" placeholder="Поиск" v-model="searchJsonLog"
                        hide-details class="hidden-sm-and-down" style="width: 70%;"></v-text-field>
                      <v-layout row wrap style="padding-top: 50px;">
                        <v-switch v-model="popupJsonLogs.filterError" label="Ошибки" color="error"></v-switch>
                        <v-switch v-model="popupJsonLogs.filterAnswer" label="Ответы" color="info"
                          hide-details></v-switch>
                      </v-layout>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-layout row>
                      <v-data-table :headers="complexJsonLog.headers" :search="searchJsonLog" :items="filteredLogs"
                        item-key="idRow" hide-actions class="elevation-1" no-results-text="Нет результатов"
                        v-model="complex.selected" style="overflow-y: scroll;  height: 500px; width: 100%;">
                        <template slot="items" slot-scope="props">
                          <tr @click="props.expanded = !props.expanded && props.item.isAnswer">
                            <td>{{ props.item.timeRow }}</td>
                            <td v-if="!props.item.isAnswer">{{ props.item.messageRow }}</td>
                            <td v-if="props.item.isAnswer">Ответы в анкетах</td>
                            <td>
                              <v-icon color="teal" v-if="props.item.isAnswer">help</v-icon>
                              <v-icon color="error" v-if="props.item.isErrorRow">error</v-icon>
                            </td>
                          </tr>
                        </template>
                        <template slot="expand" slot-scope="props">
                          <v-card color="blue-grey" dark tile flat>
                            <div v-for="item in props.item.answerRow">
                              <v-card-text style="padding: unset!important; padding-left: 20px; padding-top: 5px;">{{
                                item }}</v-card-text>
                            </div>
                          </v-card>
                        </template>
                      </v-data-table>
                    </v-layout>
                    <v-card-actions>
                      <v-btn flat @click="logsJsonClose()">Закрыть</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
              <!-- Редактирование и добавление новой ставки -->
              <div slot="widget-content">
                <v-dialog v-model="popupEdit.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editedIndex !== -1">Редактирование</span>
                      <span class="headline" v-if="editedIndex === -1">Добавление</span>
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>

                        <v-layout row v-if="readonlyFields">
                          <v-flex xs4>
                            <v-subheader>ID</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <span>{{ modalData.id }}</span>
                            <!-- <v-text-field
                              v-if="!readonlyFields"
                              label="ID"
                              v-model="modalData.id"
                              :rules="rules.account"
                              required
                            ></v-text-field> -->
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Ставка</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-autocomplete label="Ставка" :items="staffListForSelect" no-data-text="Нет данных"
                              v-model="modalData.staffId" @change="changeStaff($event)"
                              :rules="rules.staff"></v-autocomplete>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Логин</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <span v-if="readonlyFields">{{ modalData.username }}</span>
                            <v-text-field v-if="!readonlyFields" label="Логин" v-model="modalData.username"
                              :rules="rules.username" required></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Пароль</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <!-- <span v-if="readonlyFields">&#10033;&#10033;&#10033;&#10033;&#10033;</span> -->
                            <v-text-field label="Пароль" v-model="modalData.password"
                              :type="showPsw ? 'text' : 'password'"
                              :append-icon="showPsw ? 'visibility_off' : 'visibility'"
                              @click:append="showPsw = !showPsw" :rules="rules.password" required></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>ФИО</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="ФИО" v-model="modalData.fullname"
                              :rules="rules.required"></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Email</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Email" v-model="modalData.email" :rules="rules.email"></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Телефон</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Телефон" v-model="modalData.phone" :rules="rules.phone"></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Активен</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-switch v-model="modalData.isActive"></v-switch>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>UserStatus</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <td>
                              <v-chip label color="rgb(33, 156, 145)" text-color="white"
                                v-if="modalData.userStatus == 1">
                                <v-avatar tile class="teal"><v-icon small color="white"
                                    v-if="modalData.userStatus == 1">lock_open</v-icon></v-avatar>
                                Не заблокирован
                              </v-chip>
                              <v-chip label color="#f88d86" text-color="white" v-if="modalData.userStatus == 0">
                                <v-avatar tile class="error"><v-icon small color="white"
                                    v-if="modalData.userStatus == 0">lock_outline</v-icon></v-avatar>
                                Заблокирован
                              </v-chip>
                            </td>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Заказчик</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-switch v-model="modalData.isCustomer"></v-switch>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Менеджер</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-switch v-model="modalData.isManager"></v-switch>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Тестовый пользователь</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-switch v-model="modalData.isTest"></v-switch>
                          </v-flex>
                        </v-layout>

                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="editCancel()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit()">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <!-- Удаление -->
              <div slot="widget-content">
                <v-dialog v-model="popupDeactivation.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены, что хотите изменить активность аккаунта?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="popupDeactivation.isOpen = false">Отмена</v-btn>

                      <v-btn color="blue darken-1" flat @click.native="actionDeactivation(modalData);">Да,
                        уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <!-- Окно подтверждения смены ставки пользователя -->
              <div slot="widget-content">
                <v-dialog v-model="popupConfirmChangeStaff.isOpen" persistent max-width="700px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены, что хотите сохранить данные?</span>
                    </v-card-title>
                    <v-card-text style="color: red; font-size: 16px;">
                      Выбранная ставка принадлежит другому пользователю.
                      <br>
                      Назначение выбранной ставки данному пользователю ограничит доступ прежнего пользователя
                      к&nbsp;POH.
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="cancelChangeStaff()">Отмена</v-btn>

                      <v-btn color="blue darken-1" flat @click.native="confirmChangeStaff()">Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>


<script>
import Util from '@/util';
import { uuid } from 'vue-uuid'
import Logging from '../../store/modules/logging';
import UserStatus from '../../store/modules/userStatus';

export default {
  components: {},
  data() {
    return {
      pagination: { sortBy: "fileDate", descending: true, rowsPerPage: -1 }, // Сортировка по умолчанию для таблицы
      modalData: {},
      oldModalData: {},
      editedIndex: {},
      valid: true,
      showPsw: false,
      readonlyFields: true,
      filterTestAccount: false,
      rules: {
        required: [v => !!v || "Обязательное поле"],
        // account: [
        //   v => !!v || "AccountId не может быть пустым",
        //   v => this.accountList.filter(el => el.accountId === +v).length === 0 || "Такой ID уже существует"
        // ],
        // staff: [
        //   v => !!v || "StaffId не может быть пустым",
        //   v => this.accountList.filter(el => el.staffId === +v).length === 0 || "Такой ID уже существует"
        // ],
        username: [
          v => !!v || "Логин не может быть пустым",
          v => /^[a-zA-Z\d]{6,}$/.test(String(v)) || "Длина логина должна быть не менее 6 символов",
          v => this.accountList.filter(el => el.username === v).length === 0 || "Такой логин уже существует"
        ],
        password: [
          v => !!v || "Пароль не может быть пустым",
          v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(String(v)) || "Длина пароля должна быть не менее 8 символов, содержать заглавные и строчные буквы латинского алфавита, цифры"
        ],
        // email: [ 
        //   v => !!v || "Email не может быть пустым",
        //   v => Util.validateEmail(v) || "Введите корректный email",
        //   v => this.accountList.filter(acc => acc.email === v && acc.id !== this.oldModalData.id).length === 0  || "Пользователь с таким email уже существует" 
        // ],
      },
      search: "",
      searchLog: "",
      searchJsonLog: "",
      showDetailedSearch: false,
      detailedSearch: [
        {
          placeholder: "Account ID",
          searchKey: "id",
          text: ""
        },
        {
          placeholder: "Staff ID",
          searchKey: "staffId",
          text: ""
        },
        {
          placeholder: "PG код",
          searchKey: "pgName",
          text: ""
        },
        {
          placeholder: "Логин",
          searchKey: "username",
          text: ""
        },
        {
          placeholder: "ФИО пользователя",
          searchKey: "fullname",
          text: ""
        },
      ],
      popupConfirmChangeStaff: {
        isOpen: false
      },
      popupDeactivation: {
        isOpen: false
      },
      popupEdit: {
        isOpen: false,
        isEditing: false
      },
      popupLogs: {
        isOpen: false,
        nameAccount: ""
      },
      popupJsonLogs: {
        isOpen: false,
        dateLog: "",
        jsonFileUrl: "",
        fileUrl: "",
        filterError: false,
        filterAnswer: false
      },
      complex: {
        selected: [],
        headers: [
          {
            text: "Account ID",
            value: "id"
          },
          {
            text: "Staff ID",
            value: "staffId"
          },
          {
            text: "Логин",
            value: "username"
          },
          {
            text: "PG код",
            value: "pgName"
          },
          {
            text: "ФИО",
            value: "fullname"
          },
          {
            text: "Email",
            value: "email"
          },
          {
            text: "Телефон",
            value: "phone"
          },
          {
            text: "Активен",
            value: "isActive"
          },
          {
            text: "UserStatus",
            value: "userStatus"
          },
          {
            text: "Действия",
            value: ""
          }
        ]
      },
      complexLog: {
        selected: [],
        headers: [
          {
            text: "Дата",
            value: "fileDate"
          },
          {
            text: "Действия",
            value: "fileUrl"
          }
        ]
      },
      complexJsonLog: {
        selected: [],
        headers: [
          {
            text: "Время",
            value: "timeRow"
          },
          {
            text: "Сообщение",
            value: "messageRow"
          },
          {
            text: "Тип",
            value: ""
          }
        ]
      }
    };
  },

  computed: {
    /**
     * Данные о пользователях
     * @returns {default.computed.accountList|(function())|Array|getters.accountData}
     */
    accountList() {
      return this.$store.getters["account/accountData"];
    },

    /**
     * Фильтрованные данные о пользователях
     */
    filteredAccountList() {
      let result = this.accountList;

      /**
       * Поиск по детальному фильтру
       */
      this.detailedSearch.forEach(filter => {
        if (filter.text !== "") {
          result = result.filter(tsd => String(tsd[filter.searchKey]).toLowerCase().indexOf(filter.text.toLowerCase()) !== -1);
        }
      });

      // Фильтруем тестовых пользователей
      result = result.filter(tsd => tsd.isTest === this.filterTestAccount);

      return result;
    },

    /**
     * Список ставок (рабочих мест)
     * @returns {default.computed.staffList|(function())|Array|getters.staffData}
     */
    staffList() {
      return this.$store.getters['staff/staffData'];
    },

    /**
     * Список ставок (рабочих мест) для Select'a
     * @returns {default.computed.staffListForSelect|(function())|Array|getters.staffData}
     */
    staffListForSelect() {
      let result = [];

      this.staffList.forEach(st => {
        result.push({
          text: !!st.pgName ? st.pgName : '-',
          value: st.id
        });
      });

      return result;
    },

    /**
     * Данные по логам
     * @returns {default.computed.LogsServerData|(function())|Array|getters.LogsServerData}
     */
    LogsServerData() {
      return this.$store.getters["logServer/LogsServerData"];
    },

    /**
     * Данные по логам
     * @returns {default.computed.LogsServerData|(function())|Array|getters.LogsServerData}
     */
    jsonLogServerData() {
      return this.$store.getters["logServer/jsonLogServerData"];
    },

    /**
     * Фильтруем данные лога по флагу "ошибка" или "ответ"
     */
    filteredLogs() {
      let tempResponse = this.$store.getters["logServer/jsonLogServerData"];

      if (this.popupJsonLogs.filterError) {
        tempResponse = this.$store.getters["logServer/jsonLogServerData"].filter(lsd => lsd.isErrorRow === true);
      }

      if (this.popupJsonLogs.filterAnswer) {
        tempResponse = this.$store.getters["logServer/jsonLogServerData"].filter(lsd => lsd.isAnswer === true);
      }

      return tempResponse;
    },
  },

  mounted: function () {
    /**
     * Загружаем данные о пользователях и ставках при первой отрисовке страницы
     */
    if (this.accountList.length === 0 || this.staffList.length === 0) {
      this.refresh();
    }
  },

  methods: {
    /**
     * Обновление данных о пользователях
     */
    refresh() {
      this.$store._actions["account/getAccountData"][0]();
      this.$store._actions['staff/getStaffData'][0]();
    },

    /**
     * Открытие модального окна со списком файлов лога
     * @param item
     */
    logsOpen(item) {
      this.$store._actions["logServer/getLogServerData"][0]({ username: item.username });

      this.popupLogs.nameAccount = item.fullname;
      this.popupLogs.isOpen = true;
    },

    /**
     * Открытие файла лога
     */
    openUrl(item) {
      window.open(item, "_blank");
    },

    /**
     * Закрытие списка логов
     */
    logsClose() {
      this.popupLogs.isOpen = false;
    },

    /**
     * Открытие файла лога в таблице
     */
    openJsonLog(item) {
      this.$store._actions["logServer/getJsonLogServerData"][0]({ urlJsonLog: item.jsonFileUrl });

      this.popupJsonLogs.fileUrl = item.fileUrl;
      this.popupJsonLogs.jsonFileUrl = item.jsonFileUrl;
      this.popupJsonLogs.dateLog = item.fileDate;
      this.popupJsonLogs.isOpen = true;
    },

    /**
     * Закрытие списка логов
     */
    logsJsonClose() {
      this.popupJsonLogs.isOpen = false;
    },

    /**
     * Обновление данных JSON лога
     */
    refreshJsonLog(item) {
      this.$store._actions["logServer/getJsonLogServerData"][0]({
        urlJsonLog: item
      });
    },

    /**
     * Открытие модального окна с редактированием, сохраняем старые данные и индекс элемента на случай отмены редактирования
     * @param item
     */
    editOpen(item) {
      //console.debug(item)
      if (item !== null && typeof item !== "undefined") { // Если редактирование
        this.modalData = item;
        this.oldModalData = Object.assign({}, item);
        this.editedIndex = this.filteredAccountList.indexOf(item);
        this.readonlyFields = true;
      } else {// Если добавление
        this.modalData = {
          id: "-1",
          staffId: null,
          username: "",
          password: "",
          fullname: "",
          email: "",
          phone: "",
          extId: uuid.v1(),
          isActive: true,
          userStatus: 1,
          isCustomer: false,
          isManager: false,
          isTest: false
        };

        this.oldModalData = {};
        this.editedIndex = -1;
        this.readonlyFields = false;
      }

      // Флаг необходимости смены связи "accountId - staffId"
      this.modalData.staffIdChange = false;

      this.popupEdit.isOpen = true;
    },

    /**
     * Отмена редактирования
     */
    editCancel() {
      if (this.editedIndex != -1) {
        Object.assign(this.filteredAccountList[this.editedIndex], this.oldModalData);
      }

      // Удаление флага необходимости смены связи "accountId - staffId"
      delete this.modalData.staffIdChange;

      this.popupEdit.isOpen = false;
      this.refresh();
    },

    loggingData(data, initial = '', changed = '', roles = {}) {
      return {
        payload: {
          '201': `Пользователь: ${data.data.fullname ? data.data.fullname : 'ФИО не указано'}, ${data.data.email ? data.data.email : 'Email не указан'}`,
          '204': `Пользователь: ${data.data.fullname ? data.data.fullname : 'ФИО не указано'}, ${data.data.email ? data.data.email : 'Email не указан'}`,
          '205': `Пользователь: ${data.data.fullname ? data.data.fullname : 'ФИО не указано'}, ${data.data.email ? data.data.email : 'Email не указан'}`,
          '208': `Пользователь: ${data.data.fullname ? data.data.fullname : 'ФИО не указано'}, ${data.data.email ? data.data.email : 'Email не указан'}`,
          '209': `Пользователь: ${data.data.fullname ? data.data.fullname : 'ФИО не указано'}, ${data.data.email ? data.data.email : 'Email не указан'}, ${data.data.phone ? data.data.phone : 'Тел. не указан'}; Что изменено: ${changed}`,
          '213': `Пользователь: ${data.data.fullname ? data.data.fullname : 'ФИО не указано'}, ${data.data.email ? data.data.email : 'Email не указан'}, ${data.data.phone ? data.data.phone : 'Тел. не указан'}`,
          '301': `Пользователь: ${data.data.fullname ? data.data.fullname : 'ФИО не указано'}, ${data.data.email ? data.data.email : 'Email не указан'}; Назначены админ права`,
          '302': `Пользователь: ${data.data.fullname ? data.data.fullname : 'ФИО не указано'}, ${data.data.email ? data.data.email : 'Email не указан'}; ${changed}`
        },
        comment: {
        }
      }
    },

    /**
     * Сохранение отредактированного элемента
     */
    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (!this.modalData.staffIdChange && this.checkStaffIdDuplication(this.modalData.staffId)) {
        this.popupConfirmChangeStaff.isOpen = true;
      } else {
        this.modalData.extId = this.modalData.staffIdChange || !this.modalData.staffId ? uuid.v1() : this.modalData.extId;

        this.$store._actions["account/saveAccountData"][0]({ index: this.editedIndex, data: this.modalData })
          .then(async () => {
            if (this.modalData.id == -1) {
              await this.$store.dispatch('logging/commitLogData', { eventKey: '201', username: Logging.actions.getBasicBaseData().username, payload: this.loggingData({ data: this.modalData }).payload['201'] });
              //await Logging.actions.commitLogData('201', Logging.actions.getBasicBaseData().username, this.loggingData({ data: this.modalData }).payload['201']);
            } else {
              if (!this.modalData.isActive && this.oldModalData.isActive) {
                await this.$store.dispatch('logging/commitLogData', { eventKey: '205', username: Logging.actions.getBasicBaseData().username, payload: this.loggingData({ data: this.modalData }).payload['205'] });
              }
            }

            if (this.modalData.isActive && !this.oldModalData.isActive) {
              await this.$store.dispatch('logging/commitLogData', { eventKey: '208', username: Logging.actions.getBasicBaseData().username, payload: this.loggingData({ data: this.modalData }).payload['208'] });
            }

            // Удаление флага необходимости смены связи "accountId - staffId"
            delete this.modalData.staffIdChange;

            let changedModalData = Logging.actions.getChangedFields(this.oldModalData, this.modalData);
            if (this.modalData.id != -1 && changedModalData.length > 0) {
              await this.$store.dispatch('logging/commitLogData', { eventKey: '209', username: Logging.actions.getBasicBaseData().username, payload: this.loggingData({ data: this.modalData }, '', changedModalData).payload['209'] });
            }

            if (this.modalData.id != -1 && this.oldModalData.isManager != this.modalData.isManager) {
              await this.$store.dispatch('logging/commitLogData', { eventKey: '301', username: Logging.actions.getBasicBaseData().username, payload: this.loggingData({ data: this.modalData }).payload['301'] });
            }

            let changedRoles = Logging.actions.getRoles(this.oldModalData, this.modalData);
            if (this.modalData.id != -1 && changedRoles.length > 0) {
              await Logging.actions.commitLogData('302', Logging.actions.getBasicBaseData().username, this.loggingData({ data: this.modalData }, '', changedRoles).payload['302']);
            }

            this.popupEdit.isOpen = false;
            this.refresh();
          });
      }
    },

    /**
     * Открытие модального окна с подтверждением удаления
     * @param data
     */
    deactivationConfirm(data) {
      this.popupDeactivation.isOpen = true;
      this.modalData = data;
    },

    async setStatus(item) {
      let userLogin = null;
      if (item.email != null) {
        userLogin = item.email;
      } else if (item.phone != null) {
        userLogin = item.phone;
      } else {
        userLogin = item.username;
      }

      if (userLogin == null) return false;

      await this.$store.dispatch('userStatus/setStatusPerAccount', { userLogin: userLogin }).then(() => {
        this.refresh();
      });
    },

    async resetStatus(item) {
      let userLogin = null;
      if (item.email != null) {
        userLogin = item.email;
      } else if (item.phone != null) {
        userLogin = item.phone;
      } else {
        userLogin = item.username;
      }

      if (userLogin == null) return false;

      await this.$store.dispatch('userStatus/resetStatusPerAccount', { userLogin: userLogin }).then(() => {
        this.refresh();
      });
    },

    async manageStatus(item) {
      console.debug(item.userStatus, item.username)
      if (item.userStatus == 1) {
        console.warn('Setting status.');
        return await this.resetStatus(item);
      } else if (item.userStatus == 0) {
        console.warn('Resetting status.');
        return await this.setStatus(item);
      }
    },

    /**
     * Удаление элемента
     * @param item
     */
    async actionDeactivation(item) {
      item.isActive = !item.isActive;

      this.$store._actions["account/saveAccountData"][0]({ data: item });
      //this.$store._actions["account/removeAccountData"][0]({ item: item });
      if (!item.isActive) {
        await Logging.actions.commitLogData('205', Logging.actions.getBasicBaseData().username, this.loggingData({ data: this.modalData }).payload['205']);
      } else {
        await Logging.actions.commitLogData('208', Logging.actions.getBasicBaseData().username, this.loggingData({ data: this.modalData }).payload['208']);
      }
      this.popupDeactivation.isOpen = false;
    },

    /**
     * Очистка и закрытие детального фильтра
     */
    detailedSearchClear() {
      this.detailedSearch.forEach(s => (s.text = ""));
      this.showDetailedSearch = false;
    },

    /**
     * Обработка события изменения ставки (рабочего места) пользователя
     * @param staffId
     */
    changeStaff(staffId) {
      this.modalData.staffId = staffId > 0 ? staffId : null;
    },

    /**
     * Проверка на присвоение ставки, связанной с другим пользователем
     * @param staffId
     */
    checkStaffIdDuplication(staffId) {
      let result = false;

      if (staffId > 0) {
        let selectedStaffInfo = this.staffList.find(st => st.id === staffId);

        result = !!selectedStaffInfo && selectedStaffInfo.extId !== this.modalData.extId;
      }

      return result;
    },

    /**
     * Подтверждение изменения ставки (рабочего места)
     */
    confirmChangeStaff() {
      this.modalData.staffIdChange = true;

      this.submit();

      this.popupConfirmChangeStaff.isOpen = false;
    },

    /**
     * Отмена выбора ставки (рабочего места)
     */
    cancelChangeStaff() {
      this.modalData.staffIdChange = false;
      this.popupConfirmChangeStaff.isOpen = false;
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ui/Accounts.vue